import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useClearingInvoiceStats from '@/enterprise/data/useClearingInvoiceStats';
import useLocaleFormat from '@/utils/useLocaleFormat';
import { AwardedInvoiceSource } from './types';
import { buildAwardedSearch } from './utils';

const AwardedInvoiceAmount = ({ source }: { source: AwardedInvoiceSource }) => {
  const { asCurrency, asNumber } = useLocaleFormat();
  const { t } = useTranslation();
  const { makerOrganizationUuid, currency, takerMarkets } = source;

  const search = useMemo(() => buildAwardedSearch(takerMarkets), [takerMarkets]);

  const { data: awardedInvoiceStats } = useClearingInvoiceStats({
    makerOrganizationUuid,
    takerMarkets,
    ...(!!search && { search }),
  });

  return (
    <div>
      {asCurrency(awardedInvoiceStats?.totalAmount ?? 0, currency)} (
      {t('core.invoiceWithCount', {
        count: awardedInvoiceStats?.totalCount,
        formattedCount: asNumber({ value: awardedInvoiceStats?.totalCount }),
      })}
      )
    </div>
  );
};

export default AwardedInvoiceAmount;
